/**
 * 水位グラフ生成
 */
import color from "../../scss/color.scss";
import libCG, { str } from "./MbCommonGraph";

export default {
  name: "lib-mb-stage-graph",
  getSvgGraph,
  getSvgLeftLabel,
  getSvgRightLabel,
  getSvgLegend,
};

// グラフの雨量比率(30%)
const graphRainRatio = 0.3;
// グラフの水位比率(70%)
const graphStageRatio = 0.7;
// グラフ描画領域上余白
const paddingTop = 50;
// グラフ描画領域下余白
const paddingBottom = 150;
// ラベル描画領域左余白
const paddingLeft = 50;
// ラベル描画領域右余白
const paddingRight = 50;
// グラフ間余白
const paddingMiddle = 80;
// 雨量ラベル分割数
const rainDivY = 4;
// 水位ラベル分割数
const stageDivY = 8;
// ラベル表示間隔
const spaceY = 2;
// 雨量ラベル桁数（小数点以下）
const rainLabelDisit = 0;
// 水位ラベル桁数（小数点以下）
const stageLabelDisit = 1;

// 凡例サイズ
const legendWidth = 660;
const legendHeightRain = 240;
const legendHeightStage = 525;
const legendHeightStageFldCtl = 595;
const legendPadding = 10;
// 実際の表示幅
const legendViewWidth = 100;

// 「河川の水位」文字列
const strStageTitle = "河川の水位";
// 「水面の位置」文字列
const strStageLevel = "水面の位置";
// 「堤防天端」文字列は水位表現で切り替えるためパラメータを使用
// 「氾濫危険水位」文字列
const strStageDanger = "氾濫危険水位";
// 「避難判断水位」文字列
const strStageRefuge = "避難判断水位";
// 「氾濫注意水位」文字列
const strStageWarning = "氾濫注意水位";
// 「水防団待機水位」文字列
const strStageStandby = "水防団待機水位";
// 「予測水位」文字列
const strPrediction = "予測水位";
// 「洪水予報の予測値」文字列
const strPredictionLegend = "洪水予報の予測値";
// 予測値であることを補足する文字列
const strPredictionInGraph = "※予測";

// 見出し文字サイズ
const baseRainTitleSize = 68;
const baseRainTitleWeight = 500;
const baseStageTitleSize = 60;
const baseStageTitleWeight = 500;

// グラフのスタイル
const styleGraph = `<![CDATA[
  .kwg-rain-normal {
    fill: ${color.rainRainNormal};
    stroke: ${color.rainRainNormal};
    stroke-width: 1;
    opacity: 0.8;
  }
  .kwg-total-normal {
    fill: ${color.rainTotalNormal};
    stroke: ${color.rainTotalNormal};
    stroke-width: 7;
    stroke-linecap: round;
    stroke-linejoin: round;
  }
  .kwg-waterlevel-prediction {
    fill: ${color.stagePrediction};
    stroke: ${color.stagePrediction};
    stroke-width: 1;
    opacity: 1;
  }
  .kwg-waterlevel-normal {
    fill: ${color.tmStgNormal};
    stroke: ${color.tmStgNormal};
    stroke-width: 15;
    stroke-linecap: round;
    stroke-linejoin: round;
  }
  .kwg-waterlevel-top {
    fill: ${color.tmStgFlood};
    stroke: ${color.tmStgFlood};
    stroke-width: 15;
    stroke-linecap: round;
    stroke-linejoin: round;
  }
  .kwg-waterlevel-top-border {
    fill: null;
    stroke: ${color.tmStgFlood};
    stroke-width: 5;
  }
  .kwg-waterlevel-danger {
    fill: ${color.tmStgDanger};
    stroke: ${color.tmStgDanger};
    stroke-width: 15;
    stroke-linecap: round;
    stroke-linejoin: round;
  }
  .kwg-waterlevel-danger-border {
    fill: null;
    stroke: ${color.tmStgDanger};
    stroke-width: 5;
  }
  .kwg-waterlevel-refuge {
    fill: ${color.tmStgRefuge};
    stroke: ${color.tmStgRefuge};
    stroke-width: 15;
    stroke-linecap: round;
    stroke-linejoin: round;
  }
  .kwg-waterlevel-refuge-border {
    fill: null;
    stroke: ${color.tmStgRefuge};
    stroke-width: 5;
  }
  .kwg-waterlevel-warning {
    fill: ${color.tmStgWarn};
    stroke: ${color.tmStgWarn};
    stroke-width: 15;
    stroke-linecap: round;
    stroke-linejoin: round;
  }
  .kwg-waterlevel-warning-border {
    fill: null;
    stroke: ${color.tmStgWarn};
    stroke-width: 5;
  }
  .kwg-waterlevel-standby {
    fill: ${color.tmStgFldctl};
    stroke: ${color.tmStgFldctl};
    stroke-width: 15;
    stroke-linecap: round;
    stroke-linejoin: round;
  }
  .kwg-waterlevel-standby-border {
    fill: null;
    stroke: ${color.tmStgFldctl};
    stroke-width: 5;
  }
]]>`;
// 左ラベルのスタイル
const styleLeftLabel = `<![CDATA[
  .kwg-rain-label {
    fill: ${color.rainRainNormal};
    font-weight: bold;
    font-size: 72px;
  }
  .kwg-rain-title {
    fill: ${color.rainRainNormal};
    font-weight: TITLERAINWEIGHT;
    font-size: TITLERAINSIZE;
  }
  .kwg-waterlevel-label {
    fill: black;
    font-weight: bold;
    font-size: 72px;
  }
  .kwg-waterlevel-title {
    fill: black;
    font-weight: TITLESTAGEWEIGHT;
    font-size: TITLESTAGESIZE;
  }
  .kwg-waterlevel-top-marker {
    fill: ${color.tmStgFlood};
    stroke: ${color.tmStgFlood};
    stroke-width: 1;
  }
  .kwg-waterlevel-danger-marker {
    fill: ${color.tmStgDanger};
    stroke: ${color.tmStgDanger};
    stroke-width: 1;
  }
  .kwg-waterlevel-refuge-marker {
    fill: ${color.tmStgRefuge};
    stroke: ${color.tmStgRefuge};
    stroke-width: 1;
  }
  .kwg-waterlevel-warning-marker {
    fill: ${color.tmStgWarn};
    stroke: ${color.tmStgWarn};
    stroke-width: 1;
  }
  .kwg-waterlevel-standby-marker {
    fill: ${color.tmStgFldctl};
    stroke: ${color.tmStgFldctl};
    stroke-width: 1;
  }
]]>`;
// 右ラベルのスタイル
const styleRightLabel = `<![CDATA[
  .kwg-total-label {
    fill: ${color.rainTotalNormal};
    font-weight: bold;
    font-size: 72px;
  }
  .kwg-total-title {
    fill: ${color.rainTotalNormal};
    font-weight: TITLERAINWEIGHT;
    font-size: TITLERAINSIZE;
  }
]]>`;
// 凡例のスタイル
const styleLegend = `<![CDATA[
  .kwg-legend-rect {
    fill: white;
    stroke: dodgerblue;
    stroke-width: 9;
    opacity: 0.9;
  }
  .kwg-legend-label {
    fill: black;
    font-weight: 500;
    font-size: 54px;
  }
  .kwg-legend-label-unit {
    fill: black;
    font-weight: 500;
    font-size: 36px;
  }
]]>`;
// グラフ内文字のスタイル
const styleInGraph = `<![CDATA[
  .kwg-in-graph-prediction-label {
    fill: red;
    font-weight: 500;
    font-size: 54px;
  }
]]>`;

/**
 * SVGグラフ取得
 * @param obsInfo 観測所情報
 *    value[]: 観測値
 *      date: 観測日
 *      time: 観測時間
 *      rain: 雨量
 *      total: 累加雨量
 *      level: 水位レベル
 *    spec: 観測情報
 *      rain: 雨量
 *        max: 雨量最大値
 *        min: 雨量最小値
 *        title: 雨量ラベル
 *        unit: 雨量単位
 *      total: 累加雨量
 *        max: 累加雨量最大値
 *        min: 累加雨量最小値
 *        title: 累加雨量ラベル
 *        unit: 累加雨量単位
 *      level: 水位レベル（堤防天端を0.0mとした水位）
 *        max: 水位最大値
 *        top: 堤防天端（通常は0.0m）
 *        topText: 堤防天端の凡例文言
 *        danger: 氾濫危険水位
 *        refuge: 避難判断水位
 *        warning: 氾濫注意水位
 *        standby: 水防団待機水位
 *        min: 水位最小値（通常は河床-1.0m）
 *        title: 水位レベルラベル
 *        unit: 水位レベル単位
 *      prediction: 予測水位の件数
 * @param viewProp 描画プロパティ
 *    width: 親要素の幅
 *    height: 親要素の高さ
 *    isExp: 拡大/全体表示（true=拡大, false=全体）
 *    isHour: 時間/10分表示（true=時間, false=10分）
 *    showRain: 雨量グラフ表示（true=表示, false=非表示）
 *    showStage: 水位グラフ表示（true=表示, false=非表示）
 *    isFldCtl: 水防団モード（true=水防団, false=一般）
 * @return SVGグラフ
 */
function getSvgGraph(obsInfo, viewProp) {
  // svgタグ生成
  let svgGraph = libCG.makeGraphSvgTag(
    viewProp.width,
    viewProp.height,
    viewProp.isExp
  );
  // gタグ追加
  addGGraph(svgGraph, obsInfo, viewProp, false, 0);

  return svgGraph.outerHTML;
}

/**
 * グラフグループ追加
 * @param {*} parent 親要素
 * @param {*} obsInfo 観測所情報
 * @param {*} viewProp 描画プロパティ
 * @param {*} isSvg 画像提供モード
 * @param {*} offsetY 余白の高さ
 */
function addGGraph(parent, obsInfo, viewProp, isSvg, offsetY) {
  // gタグ追加
  let g = libCG.addGraphGroupTag(parent);
  // styleタグ追加
  libCG.addStyleTag(g, styleGraph);
  // グラフ表示範囲
  let x = 0;
  let y = paddingTop;
  let w = libCG.computeGraphWidth(isSvg ? false : viewProp.isExp);
  let h =
    libCG.computeHeight(viewProp.width, viewProp.height) -
    paddingTop -
    paddingBottom -
    offsetY;
  // 時刻ラベル追加
  libCG.addGraphXAxisLabelTag(
    g,
    x,
    y + h,
    w,
    obsInfo.value,
    viewProp.isExp,
    viewProp.isHour
  );

  // 雨量グラフ
  if (viewProp.showRain) {
    // 雨量グラフ表示範囲
    y = paddingTop;
    h =
      libCG.computeHeight(viewProp.width, viewProp.height) -
      paddingTop -
      paddingBottom -
      offsetY;
    if (viewProp.showStage) {
      h = h * graphRainRatio - paddingMiddle;
    }
    // 雨量フレーム追加
    libCG.addGraphFrameTag(
      g,
      x,
      y,
      w,
      h,
      obsInfo.value,
      viewProp.isExp,
      viewProp.isHour,
      rainDivY
    );
    // 雨量ツールチップ追加
    addRainGraphTooltip(g, x, y, w, h, obsInfo, viewProp);
    // 雨量グラフ追加
    addRainGraphBar(g, x, y, w, h, obsInfo, viewProp);
    // 累加雨量グラフ追加
    addTotalGraphLine(g, x, y, w, h, obsInfo, viewProp);
  }
  // 水位グラフ
  if (viewProp.showStage) {
    // 水位グラフ表示範囲
    y = paddingTop;
    h =
      libCG.computeHeight(viewProp.width, viewProp.height) -
      paddingTop -
      paddingBottom -
      offsetY;
    if (viewProp.showRain) {
      y = y + h * graphRainRatio + paddingMiddle;
      h = h * graphStageRatio - paddingMiddle;
    }
    // 水位フレーム追加
    libCG.addGraphFrameTag(
      g,
      x,
      y,
      w,
      h,
      obsInfo.value,
      viewProp.isExp,
      viewProp.isHour,
      stageDivY,
      obsInfo.spec.prediction
    );
    // 水位ツールチップ追加
    addStageGraphTooltip(g, x, y, w, h, obsInfo, viewProp);
    // 水位グラフ追加
    addStageGraphLine(g, x, y, w, h, obsInfo, viewProp);
    // 水位ボーダーライン追加
    addStageGraphBorder(g, x, y, w, h, obsInfo, viewProp);
    // グラフ内文字列追加
    addStageStrInGraph(g, x, y, w, h, obsInfo);
  }

  return g;
}

/**
 * ツールチップタグ追加
 * @param {*} parent 親要素
 * @param {*} left グラフ描画領域左端
 * @param {*} top グラフ描画領域上端
 * @param {*} width グラフ描画領域幅
 * @param {*} height グラフ描画領域高さ
 * @param {*} obsInfo 観測所情報
 * @param {*} viewProp 描画プロパティ
 */
function addRainGraphTooltip(
  parent,
  left,
  top,
  width,
  height,
  obsInfo,
  viewProp
) {
  let before = libCG.computeTimeLineBeforeOffset(
    viewProp.isExp,
    viewProp.isHour,
    obsInfo.value[0].time
  );
  let after = libCG.computeTimeLineAfterOffset(
    viewProp.isExp,
    viewProp.isHour,
    obsInfo.value[obsInfo.value.length - 1].time
  );
  let xs = width / (obsInfo.value.length + before + after);
  let x = left + width - xs * before;
  let w = xs - 2;
  let tag;
  let data;

  for (let index = 0; index < obsInfo.value.length; index++) {
    data = obsInfo.value[index];
    x = x - xs;
    if (data != null) {
      tag = libCG.makeToolTipSvgTag(
        x + 1,
        top,
        w,
        height,
        "kwg-tip",
        makeRainTip(obsInfo, data, true, true)
      );
      parent.appendChild(tag);
    }
  }
}

/**
 * 雨量棒グラフタグ追加
 * @param {*} parent 親要素
 * @param {*} left グラフ描画領域左端
 * @param {*} top グラフ描画領域上端
 * @param {*} width グラフ描画領域幅
 * @param {*} height グラフ描画領域高さ
 * @param {*} obsInfo 観測所情報
 * @param {*} viewProp 描画プロパティ
 */
function addRainGraphBar(parent, left, top, width, height, obsInfo, viewProp) {
  let cls = "kwg-rain-normal";
  let max = obsInfo.spec.rain.max;
  let min = obsInfo.spec.rain.min;

  let before = libCG.computeTimeLineBeforeOffset(
    viewProp.isExp,
    viewProp.isHour,
    obsInfo.value[0].time
  );
  let after = libCG.computeTimeLineAfterOffset(
    viewProp.isExp,
    viewProp.isHour,
    obsInfo.value[obsInfo.value.length - 1].time
  );
  let xs = width / (obsInfo.value.length + before + after);
  let x = left + width - xs * before;
  let ys = height / (max - min);
  let y;
  let tag;
  let current;

  for (let index = 0; index < obsInfo.value.length; index++) {
    current = obsInfo.value[index];
    x = x - xs;
    if (
      current != null &&
      current.rain != null &&
      current.rain <= max &&
      current.rain > min
    ) {
      y = ys * current.rain;
      tag = libCG.makeBarGraphSvgTag(
        x - (xs / 2 - 1) + 1, // 中央表示のため幅の半分だけ左にずらす
        top + 1,
        xs - 2,
        y,
        cls,
        makeRainTip(obsInfo, current, true, true)
      );
      parent.appendChild(tag);
    }
  }
}

/**
 * 累加雨量線グラフタグ追加
 * @param {*} parent 親要素
 * @param {*} left グラフ描画領域左端
 * @param {*} top グラフ描画領域上端
 * @param {*} width グラフ描画領域幅
 * @param {*} height グラフ描画領域高さ
 * @param {*} obsInfo 観測所情報
 * @param {*} viewProp 描画プロパティ
 */
function addTotalGraphLine(
  parent,
  left,
  top,
  width,
  height,
  obsInfo,
  viewProp
) {
  let cls = "kwg-total-normal";
  let max = obsInfo.spec.total.max;
  let min = obsInfo.spec.total.min;

  let before = libCG.computeTimeLineBeforeOffset(
    viewProp.isExp,
    viewProp.isHour,
    obsInfo.value[0].time
  );
  let after = libCG.computeTimeLineAfterOffset(
    viewProp.isExp,
    viewProp.isHour,
    obsInfo.value[obsInfo.value.length - 1].time
  );
  let xs = width / (obsInfo.value.length + before + after);
  let x = left + width - xs * before;
  let ys = height / (max - min);
  let x1, x2, y1, y2;
  let tag;
  let prev = null;
  let current, next;

  for (let index = 0; index < obsInfo.value.length - 1; index++) {
    current = obsInfo.value[index];
    next = obsInfo.value[index + 1];
    x = x - xs;

    if (
      current == null ||
      current.total == null ||
      current.total > max ||
      current.total <= min
    ) {
      prev = null;
      continue;
    }

    if (
      next == null ||
      next.total == null ||
      next.total > max ||
      next.total <= min
    ) {
      next = null;
    }

    x1 = x - 1;
    y1 = top + ys * (current.total - min);

    if (next != null) {
      x2 = x - xs + 1;
      y2 = top + ys * (next.total - min);
      tag = libCG.makeLineGraphSvgTag(
        x1,
        y1,
        x2,
        y2,
        cls,
        makeRainTip(obsInfo, next, false, true)
      );
      parent.appendChild(tag);
    }

    if (prev == null && next == null) {
      tag = libCG.makeCircleSvgTag(
        x1,
        y1,
        2,
        cls,
        makeRainTip(obsInfo, current, false, true)
      );
      parent.appendChild(tag);
    }

    prev = current;
  }

  if (prev == null) {
    current = obsInfo.value[obsInfo.value.length - 1];
    if (
      current != null &&
      current.total != null &&
      current.total <= max &&
      current.total > min
    ) {
      x1 = x - xs - 1;
      y1 = top + ys * (current.total - min);
      tag = libCG.makeCircleSvgTag(
        x1,
        y1,
        2,
        cls,
        makeRainTip(obsInfo, current, false, true)
      );
      parent.appendChild(tag);
    }
  }
}

/**
 * 雨量ツールチップ情報生成
 * @param {*} obsInfo 観測所情報
 * @param {*} data 観測値
 * @param {*} showRain 雨量表示
 * @param {*} showTotal 累加雨量表示
 */
function makeRainTip(obsInfo, data, showRain, showTotal) {
  let spec = obsInfo.spec;
  // 観測日時
  let tip = data.date + " " + data.time;
  // 雨量
  if (showRain) {
    tip = tip + str.CRLF + spec.rain.title + str.Sept;
    if (data != null && data.rain != null) {
      tip = tip + data.rain + spec.rain.unit;
    } else {
      tip = tip + str.None;
    }
  }
  // 累加雨量
  if (showTotal) {
    tip = tip + str.CRLF + spec.total.title + str.Sept;
    if (data != null && data.total != null) {
      tip = tip + data.total + spec.rain.unit;
    } else {
      tip = tip + str.None;
    }
  }

  return tip;
}

/**
 * 水位ツールチップタグ追加
 * @param {*} parent 親要素
 * @param {*} left グラフ描画領域左端
 * @param {*} top グラフ描画領域上端
 * @param {*} width グラフ描画領域幅
 * @param {*} height グラフ描画領域高さ
 * @param {*} obsInfo 観測所情報
 * @param {*} viewProp 描画プロパティ
 */
function addStageGraphTooltip(
  parent,
  left,
  top,
  width,
  height,
  obsInfo,
  viewProp
) {
  let before = libCG.computeTimeLineBeforeOffset(
    viewProp.isExp,
    viewProp.isHour,
    obsInfo.value[0].time
  );
  let after = libCG.computeTimeLineAfterOffset(
    viewProp.isExp,
    viewProp.isHour,
    obsInfo.value[obsInfo.value.length - 1].time
  );
  let xs = width / (obsInfo.value.length + before + after);
  let x = left + width - xs * before;
  let w = xs - 2;
  let tag;
  let data;

  for (let index = 0; index < obsInfo.value.length; index++) {
    data = obsInfo.value[index];
    x = x - xs;
    if (data != null) {
      tag = libCG.makeToolTipSvgTag(
        x + 1,
        top,
        w,
        height,
        "kwg-tip",
        makeStageTip(obsInfo, data, index)
      );
      parent.appendChild(tag);
    }
  }
}

/**
 * 水位線グラフタグ追加
 * @param {*} parent 親要素
 * @param {*} left グラフ描画領域左端
 * @param {*} top グラフ描画領域上端
 * @param {*} width グラフ描画領域幅
 * @param {*} height グラフ描画領域高さ
 * @param {*} obsInfo 観測所情報
 * @param {*} viewProp 描画プロパティ
 */
function addStageGraphLine(
  parent,
  left,
  top,
  width,
  height,
  obsInfo,
  viewProp
) {
  let cls = "kwg-waterlevel-normal";
  let spec = obsInfo.spec.level;
  let max = spec.max;
  let min = spec.min;
  let prediction = obsInfo.spec.prediction;

  let bottom = top + height;
  let before = libCG.computeTimeLineBeforeOffset(
    viewProp.isExp,
    viewProp.isHour,
    obsInfo.value[0].time
  );
  let after = libCG.computeTimeLineAfterOffset(
    viewProp.isExp,
    viewProp.isHour,
    obsInfo.value[obsInfo.value.length - 1].time
  );
  let xs = width / (obsInfo.value.length + before + after);
  let x = left + width - xs * before;
  let ys = height / (max - min);
  let x1, x2, y1, y2;
  let tag;
  let prev = null;
  let current, next;

  for (let index = 0; index < obsInfo.value.length - 1; index++) {
    current = obsInfo.value[index];
    next = obsInfo.value[index + 1];
    x = x - xs;

    if (
      current == null ||
      current.level == null ||
      current.level > max ||
      current.level < min
    ) {
      prev = null;
      continue;
    }

    if (
      next == null ||
      next.level == null ||
      next.level > max ||
      next.level < min
    ) {
      next = null;
    }

    if (spec.top != null && current.level >= spec.top) {
      cls = "kwg-waterlevel-top";
    } else if (spec.danger != null && current.level >= spec.danger) {
      cls = "kwg-waterlevel-danger";
    } else if (spec.refuge != null && current.level >= spec.refuge) {
      cls = "kwg-waterlevel-refuge";
    } else if (spec.warning != null && current.level >= spec.warning) {
      cls = "kwg-waterlevel-warning";
    } else if (
      viewProp.isFldCtl &&
      spec.standby != null &&
      current.level >= spec.standby
    ) {
      cls = "kwg-waterlevel-standby";
    } else {
      cls = "kwg-waterlevel-normal";
    }

    x1 = x - 1;
    y1 = bottom - ys * (current.level - min);

    if (next != null && index >= prediction) {
      x2 = x - xs + 1;
      y2 = bottom - ys * (next.level - min);
      tag = libCG.makeLineGraphSvgTag(
        x1,
        y1,
        x2,
        y2,
        cls,
        makeStageTip(obsInfo, next, index + 1)
      );
      parent.appendChild(tag);
    }

    if (viewProp.isExp) {
      tag = libCG.makeCircleSvgTag(
        x1,
        y1,
        null,
        cls,
        makeStageTip(obsInfo, current, index)
      );
      parent.appendChild(tag);
    } else if ((prev == null && next == null) || index < prediction) {
      tag = libCG.makeCircleSvgTag(
        x1,
        y1,
        4,
        cls,
        makeStageTip(obsInfo, current, index)
      );
      parent.appendChild(tag);
    }

    prev = current;
  }

  current = obsInfo.value[obsInfo.value.length - 1];
  if (
    current != null &&
    current.level != null &&
    current.level <= max &&
    current.level >= min
  ) {
    if (spec.top != null && current.level >= spec.top) {
      cls = "kwg-waterlevel-top";
    } else if (spec.danger != null && current.level >= spec.danger) {
      cls = "kwg-waterlevel-danger";
    } else if (spec.refuge != null && current.level >= spec.refuge) {
      cls = "kwg-waterlevel-refuge";
    } else if (spec.warning != null && current.level >= spec.warning) {
      cls = "kwg-waterlevel-warning";
    } else if (
      viewProp.isFldCtl &&
      spec.standby != null &&
      current.level >= spec.standby
    ) {
      cls = "kwg-waterlevel-standby";
    } else {
      cls = "kwg-waterlevel-normal";
    }

    x1 = x - xs - 1;
    y1 = bottom - ys * (current.level - min);

    if (viewProp.isExp) {
      tag = libCG.makeCircleSvgTag(
        x1,
        y1,
        null,
        cls,
        makeStageTip(obsInfo, current, obsInfo.value.length - 1)
      );
      parent.appendChild(tag);
    } else if (prev == null) {
      tag = libCG.makeCircleSvgTag(
        x1,
        y1,
        4,
        cls,
        makeStageTip(obsInfo, current, obsInfo.value.length - 1)
      );
      parent.appendChild(tag);
    }
  }
}

/**
 * 水位ボーダーラインタグ追加
 * @param {*} parent 親要素
 * @param {*} left グラフ描画領域左端
 * @param {*} top グラフ描画領域上端
 * @param {*} width グラフ描画領域幅
 * @param {*} height グラフ描画領域高さ
 * @param {*} obsInfo 観測所情報
 * @param {*} viewProp 描画プロパティ
 */
function addStageGraphBorder(
  parent,
  left,
  top,
  width,
  height,
  obsInfo,
  viewProp
) {
  let spec = obsInfo.spec.level;
  let max = spec.max;
  let min = spec.min;

  let bottom = top + height;
  let right = left + width;
  let ys = height / (max - min);
  let y;
  let tag;

  if (spec.top != null && spec.top <= max && spec.top >= min) {
    y = bottom - ys * (spec.top - min);
    tag = libCG.makeBorderGraphSvgTag(
      left,
      y,
      right,
      y,
      "kwg-waterlevel-top-border"
    );
    parent.appendChild(tag);
  }
  if (
    viewProp.isFldCtl &&
    spec.standby != null &&
    spec.standby <= max &&
    spec.standby >= min
  ) {
    y = bottom - ys * (spec.standby - min);
    tag = libCG.makeBorderGraphSvgTag(
      left,
      y,
      right,
      y,
      "kwg-waterlevel-standby-border"
    );
    parent.appendChild(tag);
  }
  if (spec.warning != null && spec.warning <= max && spec.warning >= min) {
    y = bottom - ys * (spec.warning - min);
    tag = libCG.makeBorderGraphSvgTag(
      left,
      y,
      right,
      y,
      "kwg-waterlevel-warning-border"
    );
    parent.appendChild(tag);
  }
  if (spec.refuge != null && spec.refuge <= max && spec.refuge >= min) {
    y = bottom - ys * (spec.refuge - min);
    tag = libCG.makeBorderGraphSvgTag(
      left,
      y,
      right,
      y,
      "kwg-waterlevel-refuge-border"
    );
    parent.appendChild(tag);
  }
  if (spec.danger != null && spec.danger <= max && spec.danger >= min) {
    y = bottom - ys * (spec.danger - min);
    tag = libCG.makeBorderGraphSvgTag(
      left,
      y,
      right,
      y,
      "kwg-waterlevel-danger-border"
    );
    parent.appendChild(tag);
  }
}

/**
 * グラフ内表示文字列追加
 * @param {*} parent 親要素
 * @param {*} left グラフ描画領域左端
 * @param {*} top グラフ描画領域上端
 * @param {*} width グラフ描画領域幅
 * @param {*} height グラフ描画領域高さ
 * @param {*} obsInfo 観測所情報
 */
function addStageStrInGraph(parent, left, top, width, height, obsInfo) {
  // 予測値であることを表す文字列
  if (obsInfo.spec.prediction > 0) {
    // styleタグ追加
    libCG.addStyleTag(parent, styleInGraph);
    let tag = document.createElement("text");
    tag.setAttribute("x", left + width - 12);
    tag.setAttribute("y", top + height - 12);
    tag.setAttribute("text-anchor", "end");
    tag.setAttribute("class", "kwg-in-graph-prediction-label");
    tag.appendChild(document.createTextNode(strPredictionInGraph));
    parent.appendChild(tag);
  }
}

/**
 * 水位ツールチップ情報生成
 * @param {*} obsInfo 観測所情報
 * @param {*} data 観測値
 * @param {*} number 要素番号
 */
function makeStageTip(obsInfo, data, number) {
  let spec = obsInfo.spec.level;
  // 観測日時
  let tip = data.date + " " + data.time;
  // 予測水位
  if (number < obsInfo.spec.prediction) {
    tip = tip + " (" + strPrediction + ")";
  }
  // 観測値
  tip = tip + str.CRLF + strStageTitle + str.Sept;
  if (data.level != null) {
    tip = tip + data.level + spec.unit;
  } else {
    tip = tip + str.None;
  }

  return tip;
}

/********** **********/

/**
 * SVG左軸取得
 * @param obsInfo 観測所情報
 *    value[]: 観測値
 *      date: 観測日
 *      time: 観測時間
 *      rain: 雨量
 *      total: 累加雨量
 *      level: 水位レベル
 *    spec: 観測情報
 *      rain: 雨量
 *        max: 雨量最大値
 *        min: 雨量最小値
 *        title: 雨量ラベル
 *        unit: 雨量単位
 *      total: 累加雨量
 *        max: 累加雨量最大値
 *        min: 累加雨量最小値
 *        title: 累加雨量ラベル
 *        unit: 累加雨量単位
 *      level: 水位レベル（堤防天端を0.0mとした水位）
 *        max: 水位最大値
 *        top: 堤防天端（通常は0.0m）
 *        topText: 堤防天端の凡例文言
 *        danger: 氾濫危険水位
 *        refuge: 避難判断水位
 *        warning: 氾濫注意水位
 *        standby: 水防団待機水位
 *        min: 水位最小値（通常は河床-1.0m）
 *        title: 水位レベルラベル
 *        unit: 水位レベル単位
 *      prediction: 予測水位の件数
 * @param viewProp 描画プロパティ
 *    width: 親要素の幅
 *    height: 親要素の高さ
 *    isExp: 拡大/全体表示（true=拡大, false=全体）
 *    isHour: 時間/10分表示（true=時間, false=10分）
 *    showRain: 雨量グラフ表示（true=表示, false=非表示）
 *    showStage: 水位グラフ表示（true=表示, false=非表示）
 *    isFldCtl: 水防団モード（true=水防団, false=一般）
 * @return SVG左ラベル
 */
function getSvgLeftLabel(obsInfo, viewProp) {
  // svgタグ生成
  let svgLeftLabel = libCG.makeLabelSvgTag(viewProp.width, viewProp.height);
  // gタグ生成
  addGLeftLabel(svgLeftLabel, obsInfo, viewProp, 0);

  return svgLeftLabel.outerHTML;
}

/**
 * 左ラベルグループ追加
 * @param {*} parent 親要素
 * @param {*} obsInfo 観測所情報
 * @param {*} viewProp 描画プロパティ
 * @param {*} offsetY 余白の高さ
 */
function addGLeftLabel(parent, obsInfo, viewProp, offsetY) {
  let spec;
  let tip;
  // 水位左ラベル表示範囲
  let x = paddingLeft;
  let y = paddingTop;
  let w = libCG.computeLabelWidth() - paddingLeft;
  let h =
    libCG.computeHeight(viewProp.width, viewProp.height) -
    paddingTop -
    paddingBottom -
    offsetY;
  // gタグ生成
  let g = libCG.addLeftLabelGroupTag(
    parent,
    viewProp.width,
    viewProp.height,
    obsInfo
  );
  // 文字サイズ算出
  let style = String(styleLeftLabel);
  const sizeRain = libCG.computeTitleSize(
    viewProp.width,
    viewProp.height,
    baseRainTitleSize,
    baseRainTitleWeight
  );
  const sizeStage = libCG.computeTitleSize(
    viewProp.width,
    viewProp.height,
    baseStageTitleSize,
    baseStageTitleWeight
  );
  style = style.replace(/TITLERAINWEIGHT/g, sizeRain.weight);
  style = style.replace(/TITLERAINSIZE/g, sizeRain.size + "px");
  style = style.replace(/TITLESTAGEWEIGHT/g, sizeStage.weight);
  style = style.replace(/TITLESTAGESIZE/g, sizeStage.size + "px");
  // styleタグ追加
  libCG.addStyleTag(g, style);
  // 雨量グラフ
  if (viewProp.showRain) {
    // 雨量グラフ表示範囲
    y = paddingTop;
    h =
      libCG.computeHeight(viewProp.width, viewProp.height) -
      paddingTop -
      paddingBottom -
      offsetY;
    if (viewProp.showStage) {
      h = h * graphRainRatio - paddingMiddle;
    }
    spec = obsInfo.spec.rain;
    // 目盛タグ追加
    libCG.addLeftLabelYAxisLabelTag(
      g,
      x,
      y,
      w,
      h,
      spec.min,
      spec.max,
      rainLabelDisit,
      rainDivY,
      spaceY,
      "kwg-rain-label",
      spec.unit
    );
    // ラベルタグ追加
    libCG.addLeftLabelYAxisTitleTag(
      g,
      x,
      y,
      w,
      h,
      spec.title,
      "kwg-rain-title"
    );
  }
  // 水位グラフ
  if (viewProp.showStage) {
    // 水位グラフ表示範囲
    y = paddingTop;
    h =
      libCG.computeHeight(viewProp.width, viewProp.height) -
      paddingTop -
      paddingBottom -
      offsetY;
    if (viewProp.showRain) {
      y = y + h * graphRainRatio + paddingMiddle;
      h = h * graphStageRatio - paddingMiddle;
    }
    spec = obsInfo.spec.level;
    // 目盛タグ追加
    libCG.addLeftLabelYAxisLabelTag(
      g,
      x,
      y,
      w,
      h,
      spec.max,
      spec.min,
      stageLabelDisit,
      stageDivY,
      spaceY,
      "kwg-waterlevel-label",
      spec.unit
    );
    // ラベルタグ追加
    libCG.addLeftLabelYAxisTitleTag(
      g,
      x,
      y,
      w,
      h,
      spec.title,
      "kwg-waterlevel-title"
    );
    // 堤防天端ボーダーマーカータグ追加
    if (spec.top != null && spec.top <= spec.max && spec.top >= spec.min) {
      tip = spec.topText + str.Sept + spec.top + spec.unit;
      libCG.addLeftLabelYAxisMarkerTag(
        g,
        x,
        y,
        w,
        h,
        spec.max,
        spec.min,
        spec.top,
        tip,
        "kwg-waterlevel-top-marker"
      );
    }
    // 水防団待機水位ボーダーマーカータグ追加
    if (
      viewProp.isFldCtl &&
      spec.standby != null &&
      spec.standby <= spec.max &&
      spec.standby >= spec.min
    ) {
      tip = strStageStandby + str.Sept + spec.standby + spec.unit;
      libCG.addLeftLabelYAxisMarkerTag(
        g,
        x,
        y,
        w,
        h,
        spec.max,
        spec.min,
        spec.standby,
        tip,
        "kwg-waterlevel-standby-marker"
      );
    }
    // 氾濫注意水位ボーダーマーカータグ追加
    if (
      spec.warning != null &&
      spec.warning <= spec.max &&
      spec.warning >= spec.min
    ) {
      tip = strStageWarning + str.Sept + spec.warning + spec.unit;
      libCG.addLeftLabelYAxisMarkerTag(
        g,
        x,
        y,
        w,
        h,
        spec.max,
        spec.min,
        spec.warning,
        tip,
        "kwg-waterlevel-warning-marker"
      );
    }
    // 避難判断水位ボーダーマーカータグ追加
    if (
      spec.refuge != null &&
      spec.refuge <= spec.max &&
      spec.refuge >= spec.min
    ) {
      tip = strStageRefuge + str.Sept + spec.refuge + spec.unit;
      libCG.addLeftLabelYAxisMarkerTag(
        g,
        x,
        y,
        w,
        h,
        spec.max,
        spec.min,
        spec.refuge,
        tip,
        "kwg-waterlevel-refuge-marker"
      );
    }
    // 氾濫危険水位ボーダーマーカータグ追加
    if (
      spec.danger != null &&
      spec.danger <= spec.max &&
      spec.danger >= spec.min
    ) {
      tip = strStageDanger + str.Sept + spec.danger + spec.unit;
      libCG.addLeftLabelYAxisMarkerTag(
        g,
        x,
        y,
        w,
        h,
        spec.max,
        spec.min,
        spec.danger,
        tip,
        "kwg-waterlevel-danger-marker"
      );
    }
  }

  return g;
}

/********** **********/

/**
 * SVG右軸取得
 * @param obsInfo 観測所情報
 *    value[]: 観測値
 *      date: 観測日
 *      time: 観測時間
 *      rain: 雨量
 *      total: 累加雨量
 *      level: 水位レベル
 *    spec: 観測情報
 *      rain: 雨量
 *        max: 雨量最大値
 *        min: 雨量最小値
 *        title: 雨量ラベル
 *        unit: 雨量単位
 *      total: 累加雨量
 *        max: 累加雨量最大値
 *        min: 累加雨量最小値
 *        title: 累加雨量ラベル
 *        unit: 累加雨量単位
 *      level: 水位レベル（堤防天端を0.0mとした水位）
 *        max: 水位最大値
 *        top: 堤防天端（通常は0.0m）
 *        topText: 堤防天端の凡例文言
 *        danger: 氾濫危険水位
 *        refuge: 避難判断水位
 *        warning: 氾濫注意水位
 *        standby: 水防団待機水位
 *        min: 水位最小値（通常は河床-1.0m）
 *        title: 水位レベルラベル
 *        unit: 水位レベル単位
 *      prediction: 予測水位の件数
 * @param viewProp 描画プロパティ
 *    width: 親要素の幅
 *    height: 親要素の高さ
 *    isExp: 拡大/全体表示（true=拡大, false=全体）
 *    isHour: 時間/10分表示（true=時間, false=10分）
 *    showRain: 雨量グラフ表示（true=表示, false=非表示）
 *    showStage: 水位グラフ表示（true=表示, false=非表示）
 *    isFldCtl: 水防団モード（true=水防団, false=一般）
 * @return SVG右ラベル
 */
function getSvgRightLabel(obsInfo, viewProp) {
  // svgタグ生成
  let svgRightLabel = libCG.makeLabelSvgTag(viewProp.width, viewProp.height);
  // gタグ生成
  addGRightLabel(svgRightLabel, obsInfo, viewProp, 0);

  return svgRightLabel.outerHTML;
}

/**
 * 右ラベルグループ追加
 * @param {*} parent 親要素
 * @param {*} obsInfo 観測所情報
 * @param {*} viewProp 描画プロパティ
 * @param {*} offsetY 余白の高さ
 */
function addGRightLabel(parent, obsInfo, viewProp, offsetY) {
  // 水位右ラベル表示範囲
  let x = 0;
  let y = paddingTop;
  let w = libCG.computeLabelWidth() - paddingRight;
  let h =
    libCG.computeHeight(viewProp.width, viewProp.height) -
    paddingTop -
    paddingBottom -
    offsetY;
  // gタグ生成
  let g = libCG.addRightLabelGroupTag(
    parent,
    viewProp.width,
    viewProp.height,
    obsInfo
  );
  // 文字サイズ算出
  let style = String(styleRightLabel);
  const sizeRain = libCG.computeTitleSize(
    viewProp.width,
    viewProp.height,
    baseRainTitleSize,
    baseRainTitleWeight
  );
  style = style.replace(/TITLERAINWEIGHT/g, sizeRain.weight);
  style = style.replace(/TITLERAINSIZE/g, sizeRain.size + "px");
  // styleタグ追加
  libCG.addStyleTag(g, style);
  // 累加雨量グラフ
  if (viewProp.showRain) {
    // 雨量グラフ表示範囲
    y = paddingTop;
    h =
      libCG.computeHeight(viewProp.width, viewProp.height) -
      paddingTop -
      paddingBottom -
      offsetY;
    h = h * graphRainRatio - paddingMiddle;
    let spec = obsInfo.spec.total;
    // 目盛タグ追加
    libCG.addRightLabelYAxisLabelTag(
      g,
      x,
      y,
      w,
      h,
      spec.min,
      spec.max,
      rainLabelDisit,
      rainDivY,
      spaceY,
      "kwg-total-label",
      spec.unit
    );
    // ラベルタグ追加
    libCG.addRightLabelYAxisTitleTag(
      g,
      x,
      y,
      w,
      h,
      spec.title,
      "kwg-total-title"
    );
  }

  return g;
}

/********** **********/

/**
 * SVG凡例取得
 * @param obsInfo 観測所情報
 *    value[]: 観測値
 *      date: 観測日
 *      time: 観測時間
 *      rain: 雨量
 *      total: 累加雨量
 *      level: 水位レベル
 *    spec: 観測情報
 *      rain: 雨量
 *        max: 雨量最大値
 *        min: 雨量最小値
 *        title: 雨量ラベル
 *        unit: 雨量単位
 *      total: 累加雨量
 *        max: 累加雨量最大値
 *        min: 累加雨量最小値
 *        title: 累加雨量ラベル
 *        unit: 累加雨量単位
 *      level: 水位レベル（堤防天端を0.0mとした水位）
 *        max: 水位最大値
 *        top: 堤防天端（通常は0.0m）
 *        topText: 堤防天端の凡例文言
 *        danger: 氾濫危険水位
 *        refuge: 避難判断水位
 *        warning: 氾濫注意水位
 *        standby: 水防団待機水位
 *        min: 水位最小値（通常は河床-1.0m）
 *        title: 水位レベルラベル
 *        unit: 水位レベル単位
 *      prediction: 予測水位の件数
 * @param viewProp 描画プロパティ
 *    width: 親要素の幅
 *    height: 親要素の高さ
 *    isExp: 拡大/全体表示（true=拡大, false=全体）
 *    isHour: 時間/10分表示（true=時間, false=10分）
 *    showRain: 雨量グラフ表示（true=表示, false=非表示）
 *    showStage: 水位グラフ表示（true=表示, false=非表示）
 *    isFldCtl: 水防団モード（true=水防団, false=一般）
 * @return SVG凡例
 */
function getSvgLegend(obsInfo, viewProp) {
  let h = legendPadding;
  if (viewProp.showRain) {
    h = h + legendHeightRain;
  }
  if (viewProp.showStage) {
    // 水位の凡例サイズは水防団モードによって変化
    if (viewProp.isFldCtl) {
      h = h + legendHeightStageFldCtl;
    } else {
      h = h + legendHeightStage;
    }
  }
  // svgタグ生成
  let svgLegend = libCG.makeLegendSvgTag(
    legendWidth + legendPadding,
    h,
    legendViewWidth
  );
  // gタグ追加
  addGLegend(svgLegend, obsInfo, viewProp);

  return svgLegend.outerHTML;
}

/**
 * 凡例グループ追加
 * @param {*} parent 親要素
 * @param {*} obsInfo 観測所情報
 * @param {*} viewProp 描画プロパティ
 */
function addGLegend(parent, obsInfo, viewProp) {
  let tag;
  let spec = obsInfo.spec;
  let w = legendWidth;
  let x = 0;
  // eslint-disable-next-line
  let y, h;
  // gタグ追加
  let g = libCG.addLegendGroupTag(parent);
  // styleタグ追加
  libCG.addStyleTag(g, styleLegend);

  // 雨量凡例
  if (viewProp.showRain) {
    h = legendHeightRain;
    y = 5;
    // 枠
    tag = libCG.makeLegendFrame(5, y, w, h, "kwg-legend-rect");
    g.appendChild(tag);
    // 凡例
    y = y + 70;
    y = libCG.addLegendTitle(
      g,
      x,
      y,
      spec.rain.title,
      "kwg-legend-label",
      spec.rain.unit,
      "kwg-legend-label-unit"
    );
    y = libCG.addLegendBarGraph(
      g,
      x,
      y,
      "kwg-rain-normal",
      spec.rain.title,
      "kwg-legend-label"
    );
    y = libCG.addLegendLineGraph(
      g,
      x,
      y,
      "kwg-total-normal",
      spec.total.title,
      "kwg-legend-label"
    );
  }
  // 水位凡例
  if (viewProp.showStage) {
    // 水位の凡例サイズは水防団モードによって変化
    if (viewProp.isFldCtl) {
      h = legendHeightStageFldCtl;
    } else {
      h = legendHeightStage;
    }
    y = viewProp.showRain ? legendHeightRain + 5 : 5;
    // 枠
    tag = libCG.makeLegendFrame(5, y, w, h, "kwg-legend-rect");
    g.appendChild(tag);
    // 凡例
    y = y + 70;
    y = libCG.addLegendTitle(
      g,
      x,
      y,
      strStageTitle,
      "kwg-legend-label",
      spec.level.unit,
      "kwg-legend-label-unit"
    );
    y = libCG.addLegendBarGraph(
      g,
      x,
      y,
      "kwg-waterlevel-prediction",
      strPredictionLegend,
      "kwg-legend-label"
    );
    y = libCG.addLegendLineGraph(
      g,
      x,
      y,
      "kwg-waterlevel-normal",
      strStageLevel,
      "kwg-legend-label"
    );
    // y = libCG.addLegendLineGraph(
    //   g,
    //   x,
    //   y,
    //   "kwg-waterlevel-top-border",
    //   spec.level.topText,
    //   "kwg-legend-label"
    // );
    y = libCG.addLegendLineGraph(
      g,
      x,
      y,
      "kwg-waterlevel-danger-border",
      strStageDanger,
      "kwg-legend-label"
    );
    y = libCG.addLegendLineGraph(
      g,
      x,
      y,
      "kwg-waterlevel-refuge-border",
      strStageRefuge,
      "kwg-legend-label"
    );
    y = libCG.addLegendLineGraph(
      g,
      x,
      y,
      "kwg-waterlevel-warning-border",
      strStageWarning,
      "kwg-legend-label"
    );
    if (viewProp.isFldCtl) {
      y = libCG.addLegendLineGraph(
        g,
        x,
        y,
        "kwg-waterlevel-standby-border",
        strStageStandby,
        "kwg-legend-label"
      );
    }
  }

  return g;
}
